module.exports = __webpack_public_path__ + "static/media/klede.1a1af695.m4a";